angular.module('impactx.approval').controller('ApprovalSelectionCtrl', ['$scope', 'dataGen', '$mdDialog', '$mdToast', ApprovalSelectionCtrl]);

function ApprovalSelectionCtrl($scope, dataGen, $mdDialog, $mdToast) {
    $scope.name = "";
    $scope.wasSelected = false;
    var controller = this;
    controller.selectedItem = null;

    this.deleteApprover = function(user, stepIndex) {
        var indexOfElement = $scope.steps[stepIndex].setEntries.indexOf(user);

        if(indexOfElement > -1) {
            $scope.steps[stepIndex].setEntries.splice(indexOfElement, 1);
        }

        if($scope.steps[stepIndex].setEntries.length < 2) {
            $scope.steps[stepIndex].mustApproveAll.selected = $scope.steps[stepIndex].mustApproveAll.entries[1];
        }
    };

    this.addApprovalStep = function() {
        let added = false;
        if($scope.isOnlyExternalApproval && $scope.externalApprovalStep) {
            $scope.isOnlyExternalApproval = false;
            added = true;
        }
        if($scope.isSelfApproval && $scope.hasSelfApproval) {
            $scope.isSelfApproval = false;
            added = true;
        }
        if(!added) {
            $scope.steps.push(controller.createEmptyApprovalStep());
        }
    };

    this.removeApprovalStep = function() {
        let removed = false;
        if($scope.steps.length <= 1 && !$scope.isOnlyExternalApproval && $scope.externalApprovalStep) {
            $scope.isOnlyExternalApproval = true;
            if($scope.steps[0])
                $scope.steps[0].setEntries = [];
            removed = true;
        }
        if($scope.steps.length <= 1 && !$scope.isSelfApproval && $scope.hasSelfApproval) {
            $scope.isSelfApproval = true;
            if($scope.steps[0])
                $scope.steps[0].setEntries = [];
            removed = true;
        }
        if(!removed) {
            if($scope.steps.length > 1) {
                $scope.steps.splice($scope.steps.length - 1, 1);
            }
        }
    };

    this.createEmptyApprovalStep = function() {
        var tmpMustApproveAll = {};
        if($scope.steps[0]) {
            angular.copy($scope.steps[0].mustApproveAll, tmpMustApproveAll);
            angular.copy($scope.steps[0].mustApproveAll.entries[1], tmpMustApproveAll.selected);
        }
        return {
            setEntries: [],
            mustApproveAll: tmpMustApproveAll
        };
    };

    this.setSelected = function(selected) {
        if(selected && !$scope.wasSelected) {
            $scope.wasSelected = true;
            controller.previousStep = $scope.steps;
            $scope.id = selected.id;
            $scope.steps = JSON.parse(JSON.stringify(selected.approvalSteps));
            controller.selectedItem = selected;
            if ($scope.steps && $scope.steps.length > 0)
            {
                $scope.isSelfApproval = false;
            }
        }
        else {
            $scope.wasSelected = false;
            $scope.id = 0;
            $scope.steps = JSON.parse(JSON.stringify($scope.steps));
            controller.selectedItem = undefined;
        }
    };

    this.saveTemplate = function(isNew, name) {
        var approvalObject = {};
        approvalObject.id = isNew ? 0 : $scope.id;
        approvalObject.name = name;
        approvalObject.approvalSteps = $scope.steps;
        var tempScope = {};
        dataGen.postAsForm(tempScope, {approval: approvalObject}, "/basket/createapprovaltemplate").then(function(data) {
            if(approvalObject.id == 0) {
                approvalObject.id = data.data.id;
                $scope.templates.push(approvalObject);
                controller.selectedItem = approvalObject;
            }
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.templateSaveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.getItemText = function(item) {
        return item && item.name ? item.name : "";
    };

    this.activateManualApproval = function() {
        var newApprovalStep = controller.createEmptyApprovalStep();
        $scope.steps = [];
        $scope.steps.push(newApprovalStep);
        $scope.isSelfApproval = !$scope.isSelfApproval;
        delete controller.selectedItem;
    };

    this.removeEntry = function(item, ev) {
        ev.stopPropagation();
        var confirm = $mdDialog.confirm()
            .title($scope.trns.deleteTemplate)
            .textContent($scope.trns.deleteTemplatePart1 + '\"' + item.name + '\"' + $scope.trns.deleteTemplatePart2)
            .targetEvent(ev)
            .ok($scope.trns.delete)
            .cancel($scope.trns.abort);

        $mdDialog.show(confirm).then(function() {
            dataGen.post({}, {id: item.id}, "/basket/deleteapprovaltemplate").then(function() {
                var tmpMustApproveAll = {};
                if($scope.templates[0].approvalSteps[0]) {
                    angular.copy($scope.templates[0].approvalSteps[0].mustApproveAll, tmpMustApproveAll);
                    angular.copy($scope.templates[0].approvalSteps[0].mustApproveAll.entries[1], tmpMustApproveAll.selected);
                }
                var emptyStep = {
                    setEntries: [],
                    mustApproveAll: tmpMustApproveAll
                };

                var index = $scope.templates.indexOf(item);
                if(index > -1) {
                    $scope.templates.splice(index, 1);
                }
                if(controller.selectedItem === item) {
                    $scope.selectedItem = {};
                    $scope.steps = [];
                    $scope.steps.push(emptyStep);
                }
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($scope.trns.templateDeletionSuccess)
                        .position("bottom right")
                        .hideDelay(10000)
                );
            });

        }, function() {
        });
    }
}